import React from 'react'

/** @deprecated Use icons from icons-v2-generated instead. */
export interface PythonIconProps {
  size?: number
  className?: string
  color?: string
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const PythonIcon: React.FC<PythonIconProps> = ({ size = 16, className = '', color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 1024 1024">
      <g
        fill={color}>
        <path
          d="M555 790.5c0 15.74 12.76 28.5 28.5 28.5s28.5-12.76 28.5-28.5s-12.76-28.5-28.5-28.5s-28.5 12.76-28.5 28.5m-143-557c0 15.74 12.76 28.5 28.5 28.5s28.5-12.76 28.5-28.5s-12.76-28.5-28.5-28.5s-28.5 12.76-28.5 28.5" /><path d="M821.524 297.714h-95.238v-95.238c0-49.905-40.572-90.476-90.476-90.476H388.19c-49.904 0-90.476 40.571-90.476 90.476v95.238h-95.238c-49.905 0-90.476 40.572-90.476 90.476v247.62c0 49.904 40.571 90.476 90.476 90.476h95.238v95.238c0 49.905 40.572 90.476 90.476 90.476h247.62c49.904 0 90.476-40.571 90.476-90.476v-95.238h95.238c49.905 0 90.476-40.572 90.476-90.476V388.19c0-49.904-40.571-90.476-90.476-90.476M202.476 669.143c-18.38 0-33.333-14.953-33.333-33.333V388.19c0-18.38 14.952-33.333 33.333-33.333h278.572c15.81 0 28.571-12.762 28.571-28.571c0-15.81-12.762-28.572-28.571-28.572h-126.19v-95.238c0-18.38 14.952-33.333 33.332-33.333h247.62c18.38 0 33.333 14.952 33.333 33.333v256.476c0 13.524-10.953 24.477-24.476 24.477H379.333c-45.047 0-81.619 36.666-81.619 81.619v104.095zm652.381-33.333c0 18.38-14.952 33.333-33.333 33.333H542.952c-15.81 0-28.571 12.762-28.571 28.571c0 15.81 12.762 28.572 28.571 28.572h126.19v95.238c0 18.38-14.952 33.333-33.332 33.333H388.19c-18.38 0-33.333-14.952-33.333-33.333V565.048c0-13.524 10.953-24.477 24.476-24.477h265.334c45.047 0 81.619-36.666 81.619-81.619V354.857h95.238c18.38 0 33.333 14.953 33.333 33.333z" />
      </g>
    </svg>

  )
}

PythonIcon.displayName = 'PythonIcon'
